import React from 'react';
import {Container, Grid} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import City from '../../../assests/images/city.svg'
import LiveLogo from '../../../assests/images/live.svg'
import queenLand from '../../../assests/images/land.svg'
import Brisbane from '../../../assests/images/brisbane.svg'
import Musuem from '../../../assests/images/museum.svg'
import Govt from '../../../assests/images/queenland.svg'
import {getImage} from "../../../utils/image";

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    imageMainWrapper: {
      backgroundColor: '#000',
      padding: '0 72px',
      color: '#fff',
      [theme.breakpoints.down('sm')]: {
          padding: '0 48px',
      },
      [theme.breakpoints.down('xs')]: {
          padding: '0 15px',
      },
    },
    imageWrapper: {
        maxWidth: '1200px',
        padding: '40.5px 0',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
        },
        [theme.breakpoints.down('xs')]: {
          padding: '20px 0',
          maxWidth: '100%',
      },
    },
    sponsorImage: {
        textAlign: 'center'
    },
  }));

function Branding(props) {
    const classes = useStyles();
    return (
    <Grid container className={classes.imageMainWrapper}>
        <Grid container className={classes.imageWrapper}>
        {
            props.data.map((brand, index)=>{
                return <Grid key={`brand_${index}`} item  md={2} xs={6} className={classes.sponsorImage}>
                    <img src={getImage(brand.image)} alt="Sponsor" />
                </Grid>
            })
        }
        </Grid>
    </Grid>
    )
}

export default Branding;